// Copyright 2026 Granite (granite.md). All rights reserved.
// Proprietary and confidential. Unauthorized copying is prohibited.

const ours = (host: string) => host === "granite.md" || host.endsWith(".granite.md");

/**
 * Keeps where a visitor came from (another site's referrer, the utm_source) in the
 * granite_came cookie, unless granite.md already did on an earlier page, so a new account
 * records it for the admin console (the API reads it at sign-up). The site sets the same cookie.
 */
export function rememberWhereVisitorCameFrom(doc: Document = document, loc: Location = location): void {
  if (/(?:^|; )granite_came=/.test(doc.cookie)) return;
  let ref = "";
  try {
    ref = doc.referrer && !ours(new URL(doc.referrer).hostname) ? doc.referrer : "";
  } catch {
    // An unreadable referrer counts as none.
  }
  const came = { r: ref.slice(0, 500), u: (new URLSearchParams(loc.search).get("utm_source") ?? "").slice(0, 100) };
  // SameSite=None: Apple and SAML sign-in return to the API with a cross-site POST.
  doc.cookie = `granite_came=${encodeURIComponent(JSON.stringify(came))}; path=/; max-age=2592000; samesite=none; secure${ours(loc.hostname) ? "; domain=granite.md" : ""}`;
}
